module.exports = __webpack_public_path__ + "static/media/Gilroy-Regular-Italic.3426440a.ttf";